import { CSSObject, styled } from '../styled';

import { BG_COLORS, TEXT_COLORS } from './styles/colors';
import { getChipSizes } from './styles/sizes';
import { ChipStyledType } from './types';

export const ChipStyled = styled('div')<ChipStyledType>(
  ({ theme, color, uppercase, variant = 'medium' }) => ({
    width: 'fit-content',
    textTransform: uppercase ? 'uppercase' : 'none',
    backgroundColor: BG_COLORS[color][theme.palette.mode],
    borderRadius: 40,

    '.chip-text': {
      color: TEXT_COLORS[color][theme.palette.mode],
      [theme.breakpoints.down('mobile')]: {
        ...theme.typography.captionSemiBold,
      },
      whiteSpace: 'nowrap',
    } as CSSObject,

    ...getChipSizes(theme, variant),
  })
);
